import React from 'react'
import CartIconModal from './CartModal';
import {  Link } from 'react-router-dom'

function HeaderIcons() {
    return (
        <>
            <Link to='/compare-Product' className='align-items-center ms-3'>
                <i className="bi bi-arrow-repeat  h4"></i>
            </Link>
            <Link to='/wishlist' className='align-items-center ms-3'>
                <i className="bi bi-heart  h4"></i>
            </Link>

            <Link to='/login' className='align-items-center ms-3'>
                <i className="bi bi-person  h4"></i>
            </Link>
            <CartIconModal />
        </>
    )
}

export default HeaderIcons